import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  loaded: false,
  data: {},
  error: {},
  searchDeliverees: [],
})

const { Types, Creators } = createActions({
  fetchDelivereesRequest: null,
  fetchDelivereesConnected: ['data'],
  fetchDelivereesError: ['error'],
  fetchDelivereesDisconnected: null,

  setSearchDeliverees: ['data'],

  getDeliveree: ['uid'],
  setDeliveree: ['deliveree'],
  setDelivereeLoading: ['val'],
})

export const delivereesRequest = state => state.set('loading', true)

export const delivereesDisconnected = state => state.set('loading', false)

export const delivereesConnected = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)

export const delivereesError = (state, { error }) => state.set('error', error).set('loading', false)

export const setSearchDelivereesReducer = (state, { data }) => state.set('searchDeliverees', data)

export const getDelivereeReducer = state => state.set('loading', true)

export const setDelivereeReducer = (state, { deliveree }) =>
  state
    .setIn(['data', deliveree.uid], deliveree)
    .set('loading', false)

export const setDelivereeLoadingReducer = (state, { val }) => state.set('loading', val)


export const delivereeReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_DELIVEREES_REQUEST]: delivereesRequest,
  [Types.FETCH_DELIVEREES_CONNECTED]: delivereesConnected,
  [Types.FETCH_DELIVEREES_DISCONNECTED]: delivereesDisconnected,
  [Types.FETCH_DELIVEREES_ERROR]: delivereesError,
  [Types.SET_SEARCH_DELIVEREES]: setSearchDelivereesReducer,

  [Types.GET_DELIVEREE]: getDelivereeReducer,
  [Types.SET_DELIVEREE]: setDelivereeReducer,
  [Types.SET_DELIVEREE_LOADING]: setDelivereeLoadingReducer,
})

export const DelivereeTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/delivereeReducer.js